import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Subscription } from "rxjs";
import { AdditionalIncomeService } from "../../../modules/statement/services/additional-income.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-complex-percent-field",
  templateUrl: "./complex-percent-field.component.html",
  styleUrls: ["./complex-percent-field.component.scss"],
  standalone: false
})
export class ComplexPercentFieldComponent implements OnInit, OnDestroy {
  @Input() fieldsLabel = "Przychody";
  @Input() amountLabel = "Netto";
  @Input() resultLabel = "VAT";
  @Input() percentLabel = "Stawka VAT";
  @Input() percentValue = null;
  @Input() initialAmount = null;
  @Input() placeholder = "";
  @Input() isDisabled = false;
  // @Input() errorKey: string;
  @Input() amountErrorKey!: string;
  @Input() percentErrorKey!: string;

  @Output() initialAmountChange = new EventEmitter<number>();
  @Output() percentValueChange = new EventEmitter<string>();
  @Output() vatChange = new EventEmitter<number>();

  constructor(
    private additionalIncomeService: AdditionalIncomeService,
    private translate: TranslateService
  ) {}

  amountErrors: string[] = [];
  percentErrors: string[] = [];
  private sub: Subscription;
  amount = 0;
  percent = "";
  calculated = null;
  public vatRates: object[] = [
    { id: 7, name: "7%" },
    { id: 19, name: "19%" }
  ];

  ngOnInit() {
    this.sub = this.additionalIncomeService.errors$.subscribe((errs) => {
      if (!errs) {
        this.amountErrors = [];
        this.percentErrors = [];
        return;
      }

      if (this.amountErrorKey) {
        this.amountErrors = errs
          .filter((e) => e?.fieldName === this.amountErrorKey)
          .flatMap((e) => e?.messages?.map((m) => this.translate.instant(m?.message)).filter(Boolean) || []);
      }

      if (this.percentErrorKey) {
        this.percentErrors = errs
          .filter((e) => e?.fieldName === this.percentErrorKey)
          .flatMap((e) => e?.messages?.map((m) => this.translate.instant(m?.message)).filter(Boolean) || []);
      }
    });

    this.amount = this.initialAmount;
    this.percent = this.percentValue;

    if (this.amount !== null && this.percent !== null) {
      this.recalculate();
    }
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  onAmountChange(value: number) {
    this.amount = value;
    this.initialAmountChange.emit(this.amount);
    this.recalculate();
  }

  onPercentChange(value: string) {
    this.percent = value;
    this.percentValueChange.emit(this.percent);

    this.recalculate();
  }

  private recalculate() {
    if (this.amount && this.percent && /^\d+(\.\d+)?$/.test(String(this.amount))) {
      this.calculated = +(this.amount * (parseInt(this.percent) / 100)).toFixed(2);
    } else {
      this.calculated = 0;
    }
    this.vatChange.emit(this.calculated);
  }

  // get amountErrors() {
  //   return this.errors?.[this.amountErrorKey] || null;
  // }
  //
  // get percentErrors() {
  //   return this.errors?.[this.percentErrorKey] || null;
  // }
}
